export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const TABLE_VIEW_AMOUNTS = [10, 20, 50, 100];

export const MOBILE_TABLE_VIEW_AMOUNT = 20;



// WEBPACK FOOTER //
// ./src/helpers/constants.js